var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Main"}},[_c('Main')],1),_c('vs-tab',{attrs:{"label":"Time"}},[_c('Time')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }